import { useNavigate } from "react-router-dom";
import { useModal } from "mui-modal-provider";
import { Confirm } from "@/organism";
import { useAuthStore, useNotificationStore } from "@/store";

export const useLogout = () => {
  const navigate = useNavigate();
  const { showModal } = useModal();

  // 🔥 zustand store 사용
  const { logout: authLogout } = useAuthStore();
  const { showSuccess, showError } = useNotificationStore();

  const logout = async () => {
    const modal = showModal(Confirm, {
      title: "로그아웃",
      content: "로그아웃하시겠습니까?",
      onOk: async () => {
        try {
          console.log("🚪 슈퍼어드민 로그아웃 시작");

          // 🔥 authStore를 통한 로그아웃
          await authLogout();

          console.log("✅ 슈퍼어드민 로그아웃 성공");

          // 🔥 성공 알림 (notificationStore 사용)
          showSuccess("로그아웃이 성공적으로 완료되었습니다.");

          // 로그인 페이지로 이동
          navigate("/login");
          modal.destroy();
        } catch (error) {
          console.error("❌ 슈퍼어드민 로그아웃 실패:", error);

          // 🔥 에러 알림 (notificationStore 사용)
          showError("로그아웃에 실패했습니다. 다시 시도해주세요.");
          modal.destroy();
        }
      },
      onCancel: () => {
        modal.destroy();
      },
    });
  };

  return { logout };
};
